module.exports = __webpack_public_path__ + "multi-cpu.png?d61cc493bced2e92d870d6c6665aaf81";